import type { ProxyUserDisconnectAnalysis, DisconnectAnalysisNode } from '../api/proxyUsers';

export const confidenceLabel = (value: string) => {
  switch (value) {
    case 'high': return '可信度较高';
    case 'medium': return '可信度中等';
    default: return '可信度较低';
  }
};

export const confidenceColor = (value: string) => {
  switch (value) {
    case 'high': return 'green';
    case 'medium': return 'gold';
    default: return 'default';
  }
};

/** One readable line per node comparing this user with the other users on it. */
export const nodeComparisonLine = (node: DisconnectAnalysisNode) => {
  const parts = [`${node.alias}：该用户掉线 ${node.user_drops} 次`];
  if (node.peer_users > 0) {
    parts.push(`同节点其他 ${node.peer_users} 位用户中 ${node.peer_users_dropped} 位掉线`);
    if (node.user_drops > 0) {
      parts.push(`该用户 ${node.user_drops_with_peer_drop_within_60s}/${node.user_drops} 次掉线与其他用户同一分钟前后`);
    }
  } else {
    parts.push('同节点没有可对比的其他用户');
  }
  if (node.same_server_peers > 0) {
    parts.push(`同游戏服其他 ${node.same_server_peers} 位中 ${node.same_server_peers_dropped} 位掉线`);
  }
  return `${parts.join('；')}。`;
};

export const sourceLabel = (analysis: ProxyUserDisconnectAnalysis) =>
  analysis.source === 'ai' ? 'AI 总结' : '规则分析';

/** Text for the "copy" buttons. */
export const buildAnalysisCopyText = (name: string, analysis: ProxyUserDisconnectAnalysis, kind: 'internal' | 'customer') => {
  if (kind === 'customer') return analysis.customer_text.trim();
  const lines = [`${name} 近 ${analysis.facts.window_hours} 小时掉线分析（${sourceLabel(analysis)}）`, '', analysis.summary.trim(), ''];
  if (analysis.hypotheses.length) {
    lines.push('可能的原因（按可能性排序）：');
    analysis.hypotheses.forEach((h, i) => {
      lines.push(`${i + 1}. ${h.title}（${confidenceLabel(h.confidence)}）`);
      h.evidence.forEach((e) => lines.push(`   支持：${e}`));
      h.against.forEach((e) => lines.push(`   反对：${e}`));
    });
  }
  if (analysis.facts.nodes.length) {
    lines.push('', '同节点对比：');
    analysis.facts.nodes.forEach((n) => lines.push(nodeComparisonLine(n)));
  }
  return lines.join('\n');
};
